module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAA8CAMAAADfciMYAAAAaVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANDQ0AAAAODg4CAgIAAAAAAAAAAAAEBAQAAAAPDw8PDw8AAAAAAAAAAAANDQ0AAAAPDw8O9FP4AAAAIXRSTlMALx8/+WoDsTry78CACPzqtUv69ezWuqtTRRfk4HJnWCeuEN8VAAAAlUlEQVQ4y+3VuRKCMBSF4avBbIQQQFbX4/s/pBmdsbqBxoaZ/PVXneYQVVpZ8JkgqghuBuk6V5GuUT4E3zTAzjSilJRKDlBk0VA6AUvAYUUc4TcFssgiiyyy2JUwq9+gYWhEWJJgUVCfj3InPleiFiTvHXzB51E4SSQb1bcvrrYPUwQxqS+sOM+/B3xeefHdAVv9Q7wB6C06bDTcKp4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hardwareTop4.png
// module id = 7rKv
// module chunks = 2